<template>
  <div class="marketplace-card-content">
    <p class="c-white comment first-comment">{{ $t('general.cards.marketplace_about') }}</p>
    <p class="c-white comment pt-2">{{ $t('general.cards.marketplace_settings') }}</p>

    <div class="marketplace-card-controls">
      <div class="mode-row">
        <MarketplaceCheckbox mode="preorder" v-model="modePreorder" />
        <ModeIcon mode="preorder" class="mode-icon">{{billing_account.comission.preorder || 3}}%</ModeIcon>
      </div>

      <div class="mode-row">
        <MarketplaceCheckbox mode="delivery" v-model="modeDelivery" />
        <ModeIcon mode="delivery" class="mode-icon">{{billing_account.comission.delivery || 3}}%</ModeIcon>
      </div>

      <div class="mode-row">
        <MarketplaceCheckbox mode="reserve" v-model="modeReserve" />
        <ModeIcon mode="reserve" class="mode-icon">{{billing_account.comission.reserve || 5}} UAH</ModeIcon>
      </div>
    </div>

    <a class="policy-link space-top c-grey" href="/docs/qrwaiter-marketplace-policy.pdf" target="_blank">
      {{ $t('marketplace.policy_agree') }}
    </a>
  </div>
</template>

<script>
import ModeIcon from "@/components/ModeIcon.vue";
import MarketplaceCheckbox from "@/components/marketplace/MarketplaceCheckbox.vue";

export default {
  computed: {
    modePreorder: {
      get() {
        return this.cafe.marketplace_modes.preorder;
      },
      set(v) {
        this.$store.commit('setMarketplaceMode', {
          mode: 'preorder',
          value: v
        });
        this.$store.dispatch('saveCafe');
      }
    },
    modeDelivery: {
      get() {
        return this.cafe.marketplace_modes.delivery;
      },
      set(v) {
        this.$store.commit('setMarketplaceMode', {
          mode: 'delivery',
          value: v
        });
        this.$store.dispatch('saveCafe');
      }
    },
    modeReserve: {
      get() {
        return this.cafe.marketplace_modes.reserve;
      },
      set(v) {
        this.$store.commit('setMarketplaceMode', {
          mode: 'reserve',
          value: v
        });
        this.$store.dispatch('saveCafe');
      }
    },
    cafe() {
      return this.$store.state.cafe;
    },
    billing_account() {
      return this.$store.state.billing_account;
    }
  },
  components: {
    ModeIcon,
    MarketplaceCheckbox
  }
};
</script>

<style scoped>
.mode-row {
  display: flex;
  align-items: center;
  margin-top: 2.3vh;
}
.marketplace-card-content {
 
  font-size: 2.3vh;
}

.mode-checkbox {
  width: 3.2vh;
  height: 3.2vh;

  background: #464646;

  border: 2px solid #464646;
  border-radius: 0.5vh;

  margin-right: 1.7vh;

  cursor: pointer;
}

.mode-description {
  background: #464646;
  color: #ededed;
  padding-left: 2vh;
  padding-right: 1vh;
  position: relative;
  left: -1vh;
  z-index: 0;
  font-size: 1.6vh;
  border-top-right-radius: 0.5vh;
  border-bottom-right-radius: 0.5vh;
}

.mode-icon {
  z-index: 2;
 
}

.first-comment {
  padding-top: 0 !important;
}

.policy-link {
  font-size: 1.7vh;
  display: block;
  line-height: normal;
}
</style>